export default __webpack_public_path__ + "img/WB_RT_NOMA_BF.7c7544ce088365948ba6af58bc4ec960.jpg";